import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { Homepage } from './Homepage';
import { Homepage as BuyersHomepage } from './buyers/Homepage';
import { TermsAndConditions } from './TermsAndConditions';
import { ContactUs } from './ContactUs';
import { Pricing } from './Pricing';
import { Pricing as BuyersPricing } from './buyers/Pricing';
import { List } from './BlogList';
import { DetailsView } from './BlogDetailsView';
import { List as JobsList } from './JobsList';
import { DetailsView as JobsDetailsView } from './JobsDetailsView';
import { Plus } from './Plus';
import EmailTemplateDemo from './EmailTemplateDemo';
import { UnsubscribePage } from './UnsubscribePage';
import { UnsubscribeSuccessPage } from './UnsubscribeSuccessPage';

export const WebsiteRoutes = () => {
  return (
      <Routes>
        <Route path={"/terms-and-conditions"} element={<TermsAndConditions />} />
        <Route path={"/contact-us"} element={<ContactUs />} />
        <Route path={"/buyers"} element={<Homepage />} />
        <Route path={"/pricing"} element={<Pricing />} />
        <Route path={"/job_ads"} element={<JobsList />} />
        <Route path={"/job_ad/:slug"} element={<JobsDetailsView />} />
        <Route path={"/job_ads/:slug"} element={<JobsDetailsView />} />
        <Route path={"/unsubscribe/:listName/:token"} element={<UnsubscribePage />} />
        <Route path={"/unsubscribed-successfully"} element={<UnsubscribeSuccessPage />} />
        <Route path={"/buyers/pricing"} element={<Pricing />} />
        <Route path={"/blog"} element={<List />} />
        <Route path={"/blog/:slug"} element={<DetailsView />} />
        <Route path={"/plus"} element={<Plus />} />
        <Route path={"/email-template-demo"} element={<EmailTemplateDemo />} />
        <Route path={"/"} element={<Homepage />} />
      </Routes>
  );
};
